// Cognito OIDC (Authorization Code + PKCE) configuration for Orenda.
//
// Postman equivalent:
//   Auth URL:         https://bopayments.auth.eu-west-1.amazoncognito.com/oauth2/authorize
//   Access Token URL: https://bopayments.auth.eu-west-1.amazoncognito.com/oauth2/token
//   Grant type:       Authorization Code (With PKCE)
//   Callback URL:     http://localhost:3003/orenda-callback
//   Client ID:        <the same client id you use in Postman>
//   Client Secret:    (empty for public/SPA clients)
//
// The `authority` here is the Cognito user-pool issuer URL. oidc-client-ts
// discovers /authorize, /token, /userinfo, JWKS, etc. from
// `${authority}/.well-known/openid-configuration`.
//
// IMPORTANT: replace the placeholders below with the values you already used
// successfully in Postman. The Cognito App Client in the AWS Console must:
//   - Have "Authorization code grant" enabled
//   - NOT have a client secret (public client / SPA)
//   - Have the exact `redirect_uri` below registered as a Callback URL

export const orendaOidcConfig = {
  // Cognito user-pool issuer (matches the `iss` claim in issued tokens).
  // Format: https://cognito-idp.<region>.amazonaws.com/<userPoolId>
  authority: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_7hNMPxwoN",

  // Same client id you paste into Postman's "Client ID" field.
  client_id: "5g5vc7781tneu4uj3cuho2631i",

  // Where Cognito will send the auth code back to. Must be registered as a
  // Callback URL on the Cognito App Client, exact match.
  redirect_uri: "https://card-console.com/orenda/login",

  // Where Cognito redirects after logout. Must be in Cognito's Sign-out URL list.
  post_logout_redirect_uri: "https://card-console.com/orenda/logout",

  // Federated identity provider inside Cognito that we want to delegate to.
  // With this passed on /oauth2/authorize, Cognito skips its own login page
  // and jumps straight to Microsoft Entra. Confirmed by Orenda (Christian).
  identity_provider: "bopayments-entra",

  // App Client only has `openid` and `email` enabled — requesting `profile`
  // triggers Cognito's invalid_scope error on /oauth2/authorize.
  scope: "openid email",

  // Code + PKCE (Cognito supports this for public SPA clients).
  response_type: "code",

  // Where MSAL used sessionStorage; keep parity.
  // (oidc-client-ts default is sessionStorage, so this is documentation only.)
  automaticSilentRenew: true,

  // Cognito's logout endpoint uses a slightly different URL layout — set this
  // so signoutRedirect() hits the right endpoint.
  metadataUrl:
    "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_7hNMPxwoN/.well-known/openid-configuration",
};
